<template>
  <nav class="navbar">
    <div class="logo">
      <router-link to="/" class="logo-link">
        <img style="width: 60px;height: 55px;" src="../assets/logo-FCD-200-x-180-px-1.webp" />
      </router-link>
    </div>

    <div class="nav-links" :class="{ 'open': isMobileMenuOpen }">
      <router-link v-for="item in menuItems" :key="item.name" :to="item.path" class="nav-link">
        {{ item.name }}
      </router-link>
    </div>

    <router-link to="/recovery" class="nav-btn">Start Recovery →</router-link>

    <div class="hamburger" @click="isMobileMenuOpen = !isMobileMenuOpen">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      isMobileMenuOpen: false,
      menuItems: [
        { name: 'Home', path: '/' },
        { name: 'Our Services', path: '/our-popular-services' },
        { name: 'About Us', path: '/about-our-services' },
        { name: 'Help Centre', path: '/help-centre-crypto-recovery-support' },
        { name: 'Blogs', path: '/blogs' },
        { name: 'Privacy Policy', path: '/privacy-policy-crypto-fraud' }
      ],
    };
  }
}
</script>

<style scoped>
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #0b0d13;
  width: 100%;
  padding: 20px 5%;
  position: relative;
}

.logo-link {
  text-decoration: none;
  color: #fff;
  font-weight: bold;
  font-size: 1.5rem;
  flex: 0 0 auto;
}

.nav-links {
  display: flex;
  gap: 30px;
}

.nav-link {
  position: relative;
  color: #ffffff;
  font-size: 1.2rem;
  text-decoration: none;
  padding: 5px 0;
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: #4fd1c5;
  text-shadow: 0 0 10px rgba(79, 209, 197, 0.5);
}

.nav-link::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -5px;
  width: 0%;
  height: 3px;
  border-radius: 2px;
  background: linear-gradient(90deg, #8e2de2, #00d2ff);
  transition: width 0.3s ease;
}

.nav-link:hover::after {
  width: 100%;
}

.nav-btn {
  background: linear-gradient(90deg, #8e2de2, #00d2ff);
  border: none;
  color: #fff;
  padding: 12px 24px;
  border-radius: 50px;
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
  transition: transform 0.2s;
  display: inline-block;
}

.nav-btn:hover {
  transform: scale(1.05);
}

.hamburger {
  display: none;
  cursor: pointer;
  flex-direction: column;
  gap: 5px;
}

.hamburger span {
  display: block;
  width: 25px;
  height: 3px;
  background-color: #fff;
  border-radius: 2px;
}

@media (max-width: 768px) {

  .nav-links {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: #0b0d13;
    flex-direction: column;
    padding: 20px 5%;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.5);
    z-index: 100;
    gap: 20px;
  }

  .nav-links.open {
    display: flex;
  }

  .hamburger {
    display: flex;
  }

  .nav-btn {
    flex: 1;
    text-align: center;
    margin: 0 15px;
    padding: 10px 20px;
    font-size: 0.95rem;
  }
}
</style>